import { addUserTransfer } from "@/apis/user";
import { useConfigContext } from "@/app";
import { CustomerIcon } from "@/components/CustomerIcon";
import { Icon } from "@/components/Icon";
import { Level } from "@/components/Level";
import SubLayout from "@/components/SubLayout";
import { TradeBoard } from "@/components/TradeBoard";
import { useGlobalVerify } from "@/logic/verify";
import { useUserAuthContext } from "@/routes/routesAuths/userAuth";
import { amountFormat } from "@/utils/tool";
import { Avatar, Button, Form, Input, Toast } from "antd-mobile";
import styles from "./index.module.scss";
type Data = {
  walletAddress?: string;
  amount?: string;
};
export function PageUserTransfer() {
  const [form] = Form.useForm();
  const {
    user
  } = useUserAuthContext();
  const {
    getSourcePath
  } = useConfigContext();
  const [verifySecurePassword] = useGlobalVerify();
  const submit = async (securePassword: string, value: any) => {
    if (securePassword && securePassword.length === 6) {
      const {
        ok,
        msg
      } = await addUserTransfer({
        ...value,
        securePassword
      });
      if (ok) {
        Toast.show("转账成功");
        form.resetFields();
      } else {
        Toast.show(msg || "转账失败");
      }
    }
  };
  const onSubmit = async () => {
    const fieldsValues = form.getFieldsValue();
    if (!fieldsValues.walletAddress) return Toast.show("请输入转账地址");
    if (!fieldsValues.amount) return Toast.show("请输入转账金额");
    const code = await verifySecurePassword();
    if (code) {
      submit((code as string), fieldsValues);
    }
  };
  return <SubLayout title={"个人转账"} header={{
    extra: <CustomerIcon />
  }} footer={<div>
          <div className={styles.tip}>注：该功能仅允许向商户钱包地址转账</div>
          <Button className={"common-submit-button"} onClick={() => {
      onSubmit();
    }}>
            确认转账
          </Button>
        </div>} data-sentry-element="SubLayout" data-sentry-component="PageUserTransfer" data-sentry-source-file="index.tsx">
      <TradeBoard contentClassName={styles.boardContent} backgroundClassName={styles.boardBackground} background={<>
            <div className={styles.content}>
              <Avatar className={styles.avatar} alt="avatar" src={getSourcePath(user.avatar)} />
              <div>
                <div className={styles.username}>{user.nickname}</div>
                <div className={styles.levelWrapper}>
                  <div className={styles.levelLabel}>信用等级</div>
                  <Level level={user.creditLevel} />
                </div>
              </div>
            </div>
          </>} data-sentry-element="TradeBoard" data-sentry-source-file="index.tsx">
        <div className={styles.validAmount}>可用余额</div>
        <div className={styles.amount}>
          <span>{amountFormat(user.balance)}</span>
          <Icon name={"vcoin"} className={styles.amountIcon} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
        </div>
      </TradeBoard>

      <Form form={form} className={styles.form} data-sentry-element="Form" data-sentry-source-file="index.tsx">
        <Form.Item name="walletAddress" label="钱包地址" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <Input placeholder="请输入收款商户钱包地址" data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        </Form.Item>

        <Form.Item name="amount" label="转账金额" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <Input placeholder="请输入转账金额" data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        </Form.Item>
      </Form>
    </SubLayout>;
}